import { useEffect, useRef } from 'react';

declare global {
  interface Window {
    adsbygoogle: unknown[];
  }
}

interface AdBannerProps {
  slot?: string;
  format?: 'auto' | 'horizontal' | 'vertical' | 'rectangle';
  className?: string;
  refreshKey?: number;
}

export default function AdBanner({
  slot,
  format = 'auto',
  className = '',
  refreshKey = 0,
}: AdBannerProps) {
  const adRef = useRef<HTMLModElement>(null);

  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch {
      // AdSense not loaded or blocked
    }
  }, [refreshKey]);

  const publisherId = import.meta.env.VITE_ADSENSE_PUBLISHER_ID;
  if (!publisherId) return null;

  // Format-specific styling
  const isHorizontal = format === 'horizontal';
  const isRectangle = format === 'rectangle';

  // Horizontal: constrain to small mobile banner (50px height)
  // Rectangle: allow medium rectangle size (250x250 or similar)
  const containerStyle = isHorizontal
    ? { maxHeight: '50px', overflow: 'hidden' }
    : isRectangle
      ? { minHeight: '250px', maxHeight: '300px' }
      : {};

  const insStyle = {
    display: 'block' as const,
    minHeight: isHorizontal ? '32px' : isRectangle ? '250px' : undefined,
    maxHeight: isHorizontal ? '50px' : isRectangle ? '300px' : undefined,
  };

  return (
    <div className={`ad-banner ${className}`} style={containerStyle}>
      <ins
        key={refreshKey}
        ref={adRef}
        className="adsbygoogle"
        style={insStyle}
        data-ad-client={publisherId}
        data-ad-slot={slot || ''}
        data-ad-format={format}
        data-full-width-responsive={!isHorizontal ? 'true' : undefined}
      />
    </div>
  );
}
